import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';

import FilepickerInput from './filepicker-input';

const FilepickerInputWrapper = ({ name, options }) => (
  <Field name={name} options={options} component={FilepickerInput} />
);

export default FilepickerInputWrapper;

FilepickerInputWrapper.propTypes = {
  name: PropTypes.string,
  options: PropTypes.object,
};
